<template>
  <div>
    <v-row class="ma-0 pt-2" align="center" justify="center">
      <v-col cols="4" class="lable-text pl-2"> Entry Price </v-col>
      <v-col
        style="font-weight: 500; font-size: 15px; line-height: 20px; color: #333333"
        class="font-weight-medium"
      >
        ₹{{ entry_price }}
      </v-col>
    </v-row>

    <v-row class="ma-0" align="center" justify="center">
      <v-col cols="4" sm="4" class="lable-text pa-2" style="white-space: nowrap">
        <div class="mb-6 mt-2">Target Price</div>
        <div>Stop Loss</div>
      </v-col>
      <v-col cols="8" class="px-0">
        <v-slide-group class="my-slider px-0" :show-arrows="$vuetify.breakpoint.xsOnly">
          <!-- <template v-slot:next>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
          <template v-slot:prev>
            <v-icon>mdi-chevron-left</v-icon>
          </template> -->
          <v-slide-item>
            <v-col class="fill-width" id="trailingDiv">
              <div class="stepper-horizontal">
                <div
                  v-for="(target_stop_loss, index) in new_target_stop_loss_list"
                  :key="index"
                  :class="getClass(target_stop_loss)"
                >
                  <div class="step-title">₹{{ target_stop_loss.target_price }}</div>
                  <div class="step-circle" />
                  <div class="step-bar-left"></div>
                  <div class="step-bar-right"></div>
                </div>
              </div>
              <div class="stepper-horizontal">
                <div
                  v-for="(target_stop_loss, index) in new_target_stop_loss_list"
                  :key="index"
                  :class="getClass(target_stop_loss)"
                >
                  <div class="step-title">₹{{ target_stop_loss.stop_loss }}</div>
                  <div class="step-circle" />
                  <div class="step-bar-left"></div>
                  <div class="step-bar-right"></div>
                </div>
              </div>
            </v-col>
          </v-slide-item>
        </v-slide-group>
      </v-col>
    </v-row>
    <v-row class="ma-0 py-2" align="center" justify="center" v-if="status === 'Closed'">
      <v-col cols="4" class="lable-text pl-2"> Exit Price </v-col>
      <v-col
        style="font-weight: 500; font-size: 15px; line-height: 20px; color: #333333"
        class="font-weight-medium"
      >
        ₹{{ exit_price }}
      </v-col>
    </v-row>
    <v-row class="ma-0 pt-2">
      <v-col>
        <v-row class="ma-0" align="center">
          <span class="lable-text px-2">
            {{ pandlTitle }}
            <v-tooltip max-width="300" content-class="tooltip" color="#F7FAFF" right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small> mdi-information-outline </v-icon>
              </template>
              <span class="tooltip-text">{{ pandlContent }}</span>
            </v-tooltip>
          </span>
          <v-chip class="mx-2" label :color="pl_data > 0 ? '#27AE601F' : '#EB57571F'">
            <v-icon small :color="pl_data > 0 ? '#27AE60' : '#EB5757'">
              {{ profitLossIcon }}
            </v-icon>
            <span :class="getPLTextClass('font-weight-bold text-subtitle-1')">
              ₹{{ Math.abs(pl_data) }}({{ pl_percent }}%)
            </span>
          </v-chip>
        </v-row>
      </v-col>
      <v-col>
        <v-row class="ma-0" align="center">
          <span class="lable-text px-2">
            Duration
            <v-tooltip max-width="300" content-class="tooltip" color="#F7FAFF" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small> mdi-information-outline </v-icon>
              </template>
              <span
                class="tooltip-text black--text"
                v-for="item in duration_type"
                :key="item.id"
              >
                {{ item.name }} <br />
              </span>
            </v-tooltip>
          </span>
          <span class="font-weight-black mx-2" style="color: #333333">
            {{ duration_name }}
          </span>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    "target_stop_loss_list",
    "trade_type",
    "live_price",
    "entry_price",
    "exit_price",
    "profit_percent",
    "status",
    "duration_type",
    "duration_name",
    "pl_data",
    "stop_loss",
    "target_price",
    "pl_percent",
  ],
  data() {
    return {
      currentStep: 0,
      is_current_set: false,
      numSteps: this.target_stop_loss_list.length,
      new_target_stop_loss_list: [...this.target_stop_loss_list],
    };
  },
  computed: {
    tradeStatus() {
      if (this.status == "Active") {
        return "Live";
      } else if (this.status == "Inactive") {
        return "Upcoming";
      } else {
        return this.status;
      }
    },
    pandlContent() {
      if (this.status == "Active") {
        return "P & L of the live trade as per the entry price";
      } else if (this.status == "Inactive") {
        return "Profit that can be earned through this trade.";
      } else if (this.status == "Closed") {
        return "P & L of the past trade.";
      } else {
        return "P & L of the expired trade";
      }
    },
    profitLossIcon() {
      if (this.pl_data > 0) {
        return "mdi-arrow-up";
      } else if (this.pl_data < 0) {
        return "mdi-arrow-down";
      } else {
        return "";
      }
    },
    pandlTitle() {
      if (this.status === "Inactive") {
        return "Profit Potential";
      } else if (this.status === "Active") {
        return "Current P&L";
      } else if (this.status === "Closed") {
        return "Realized P&L";
      }
      return "";
    },
  },
  methods: {
    getClass(details) {
      // console.log(details);
      if (details.done) {
        return "step done";
      } else if (details.editing) {
        return "step editing";
      }
      return "step";
    },
    getTextClass(classText) {
      if (this.profit_percent > 0) {
        return classText + " greenColor";
      } else {
        return classText + " redColor";
      }
    },
    scrollRight() {
      document.getElementById("trailingDiv").scrollRight += 20;
    },
    scrollLeft() {
      document.getElementById("trailingDiv").scrollLeft += 20;
    },
    getPLTextClass(classText) {
      if (this.pl_data > 0) {
        return classText + " greenColor";
      } else {
        return classText + " redColor";
      }
    },
  },
  created() {
    this.new_target_stop_loss_list.every((element) => {
      element.done = false;
      element.editing = false;
      // if (this.tradeStatus === "Upcoming") {
      //   if (this.live_price > element.target_price) {
      //     element.done = true;
      //     return true;
      //   } else if (
      //     this.live_price <= element.target_price &&
      //     this.live_price >= element.stop_loss
      //   ) {
      //     element.editing = true;
      //     return false;
      //   }
      // } else {
      //   if (this.target_price > element.target_price) {
      //     element.done = true;
      //     return true;
      //   } else if (
      //     this.target_price <= element.target_price &&
      //     this.stop_loss >= element.stop_loss
      //   ) {
      //     element.editing = true;
      //     return false;
      //   }
      // }
      if (this.target_price > element.target_price) {
        element.done = true;
        return true;
      } else if (
        this.target_price <= element.target_price &&
        this.stop_loss >= element.stop_loss
      ) {
        element.editing = true;
        return false;
      }
    });
  },
};
</script>

<style scoped>
.greenColor {
  color: #27ae60;
}
.redColor {
  color: #eb5757;
}
.greyColor {
  color: #333333;
}
.fill-width {
  width: 100%;
  height: 100%;
  overflow: auto;
  flex-wrap: nowrap;
  padding-bottom: 17px;
  box-sizing: content-box;
}
.lable-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: rgba(51, 51, 51, 0.64);
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent; /* make scrollbar transparent */
}
div.v-slide-group.v-item-group.v-slide-group__next {
  width: 0px !important;
  min-width: 0px !important;
}
div.my-slider.v-slide-group > .v-slide-group__prev {
  width: 0px !important;
  min-width: 0px !important;
}
</style>

<style lang="scss" scoped>
$fill-color: #199473;
$border-color: #d9e2ec;
$text-color: #102a43;
$text-color-inactive: #829ab1;
$text-color-optional: #9fb3c8;
$slide-group-prev-basis: 0px;
.stepper-horizontal {
  display: table;
  width: 100%;
  margin: 0 auto;
  .step {
    display: table-cell;
    position: relative;
    // padding: 0.5rem;
    z-index: 2;
    width: 25%;
    min-width: 140px;
    &:last-child .step-bar-left,
    &:last-child .step-bar-right {
      display: none;
    }

    .step-circle {
      width: 0.5rem;
      height: 0.5rem;
      margin-left: 11px;
      border-radius: 50%;
      text-align: center;
      line-height: 1rem;
      font-size: 0.5rem;
      font-weight: 600;
      z-index: 2;
      border: 2px solid $border-color;
    }

    &.done {
      .step-circle {
        background-color: $fill-color;
        border: 2px solid $fill-color;
        color: #ffffff;
        * {
          display: none;
        }
      }
      // .step-title {
      //   color: $text-color;
      // }
    }

    &.editing {
      .step-circle {
        background: #ffffff;
        background-color: $fill-color;
        border: 2px solid $fill-color;
        color: $fill-color;
      }
      .step-title {
        color: #333333;
      }
    }

    .step-title {
      margin-bottom: 0.1rem;
      font-size: 13px;
      font-weight: 600;
    }
    .step-title,
    .step-optional {
      text-align: left;
      color: $text-color-inactive;
    }
    .step-optional {
      font-size: 0.75rem;
      font-style: italic;
      color: $text-color-optional;
    }

    .step-bar-left,
    .step-bar-right {
      position: absolute;
      top: calc(1.5rem + 3px);
      height: 1.5px;
      background-color: $border-color;
      border: solid $border-color;
      border-width: 2px 0;
    }
    .step-bar-left {
      width: calc(100% - 1rem);
      left: calc(12% + 2px);
      margin-left: calc(1rem - 9% -3px);
      z-index: -1;
    }

    .step-bar-right {
      width: calc(100% - 1rem);
      left: calc(12% + 7px);
      margin-left: calc(1rem - 9% - 0px);
      z-index: -1;
      transition: width 500ms ease-in-out;
    }

    // &.done .step-bar-left,
    // &.editing .step-bar-left {
    //   //   background-color: $fill-color;
    //   //   border-color: $fill-color;
    //   // z-index: 3;
    // }
    &.done .step-bar-right {
      background-color: $fill-color;
      border-color: $fill-color;
      z-index: 3;
      width: calc(100% - 1rem - 2px);
    }
  }
}
</style>
